export default __webpack_public_path__ + "static/media/latest-editions-2.58499e43.png";